export default "__VITE_ASSET__DYotvjwp__"